var AwsServiceClientImpl = (function () {
    function AwsServiceClientImpl(proxy) {
        this.proxy = proxy;
    }
    AwsServiceClientImpl.prototype.execute = function (request, decoder) {
        return this.proxy.execute(request, decoder);
    };
    return AwsServiceClientImpl;
}());
export default AwsServiceClientImpl;
//# sourceMappingURL=AwsServiceClientImpl.js.map